/**
 * @description: 艺人台费扣款明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wr-ytkm-report">
        <div class="yt-list">
            <p class="p-hint">注：账户退回金额是指退回用户在巨嗨佳人台费账户的余额里</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ytTime">
                        <input type="text" class="form-control laydate-icon" v-model="ytStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ytEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ytShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">包厢类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢类型" ref="ytBoxType"></select>
                </div>
                <label class="list-label-4">上钟包厢:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择上钟包厢" ref="ytBox"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-2">艺人:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="yt_user" placeholder="请输入艺人姓名">
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="yt_group_txt" ref="yt_group_txt" readonly @click="ytEnterGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-2">主管:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="yt_charger" data-placeholder="请选择主管"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYtTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYtExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ytList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ytExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ytExport_allcheck' @click='ytExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="stage_name">
                            <label>艺人姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="director_name">
                            <label>主管</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="room_name">
                            <label>上钟包厢</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="room_type_name">
                            <label>包厢类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="last_balance">
                            <label>上次余额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="create_time">
                            <label>扣费时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="fee">
                            <label>扣费金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="refund_fee">
                            <label>账户退回金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytExport_checkModel' value="current_balance">
                            <label>本次余额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ytExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ytExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="yt-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="yt_group_name">
                <img src="../../../assets/images/group_search.png" @click="getYtGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='yt_group_allcheck' @click='groupYtCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in yt_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='yt_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row" style="padding-top: 30px;">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="ytGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="ytGroupSub()">确定</button>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ytStartTime: "",
                ytEndTime: "",
                yt_user: '',
                yt_group_txt: "",
                yt_group_allcheck: false,
                yt_c_group_allcheck: false,
                yt_group_checkboxModel: [],
                c_yt_group_checkboxModel: [],
                yt_group_checkboxData: [],
                yt_group_name: '',
                ytExport_allcheck: false,
                c_ytExport_allcheck: false,
                ytExport_checkModel: [],
                ytExport_checkData: ['shop_name', 'group_name', 'stage_name', 'director_name', 'room_name', 'room_type_name', 'last_balance', 'create_time', 'fee', 'refund_fee', 'current_balance'],
                ytExport_type: 1,
            }
        },
        watch: {
            yt_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.yt_group_checkboxModel.length >= this.yt_group_checkboxData.length) {
                        this.yt_group_allcheck = true;
                        this.yt_c_group_allcheck = true;
                    } else {
                        this.yt_group_allcheck = false;
                        this.yt_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            ytExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ytExport_checkModel.length >= this.ytExport_checkData.length) {
                        this.ytExport_allcheck = true;
                        this.c_ytExport_allcheck = true;
                    } else {
                        this.ytExport_allcheck = false;
                        this.c_ytExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ytStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.ytEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ytStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ytEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.ytStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ytEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ytTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    maxDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ytStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.ytEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ytShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.yt_group_checkboxModel = [];
                                _this.yt_group_txt = '';
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.ytBoxType).val('').trigger('change');
                                    $(_this.$refs.ytBoxType).prop('disabled', true);
                                    // 上钟包厢
                                    $(_this.$refs.ytBox).val('').trigger('change');
                                    $(_this.$refs.ytBox).prop('disabled', true);
                                    // 主管
                                    $(_this.$refs.yt_charger).val('').trigger('change');
                                    $(_this.$refs.yt_charger).prop("disabled", true);
                                    return;
                                }
                                // 上钟包厢
                                $(_this.$refs.ytBox).prop('disabled', false);
                                _this.getRoomdata(e.params.data.id);
                                // 主管
                                $(_this.$refs.yt_charger).prop("disabled", false);
                                _this.getChargeData(e.params.data.id);
                                $(_this.$refs.ytBoxType).prop('disabled', false);
                                _this.getBoxType(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.ytShop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.ytBoxType).prop('disabled', false);
                            _this.getBoxType($(_this.$refs.ytShop).val());
                            // 上钟包厢
                            $(_this.$refs.ytBox).prop('disabled', false);
                            _this.getRoomdata($(_this.$refs.ytShop).val());
                            // 主管
                            $(_this.$refs.yt_charger).prop("disabled", false);
                            _this.getChargeData($(_this.$refs.ytShop).val());
                            _this.setShopDefaultTime($(_this.$refs.ytShop).val());

                            _this.innitYtTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢类型
            getBoxType: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getRoomType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result.data, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            // 初始化
                            $(_this.$refs.ytBoxType).html('');
                            $(_this.$refs.ytBoxType).select2({
                                data: arr,
                                language: "zh-CN",
                                minimumResultsForSearch: -1,
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ytBox).html("");
                            $(_this.$refs.ytBox).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 获取主管
            getChargeData: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getDirectorSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: ' ', text: '全部', type: '' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name, type: v.type });
                            });
                            $(_this.$refs.yt_charger).html('');
                            $(_this.$refs.yt_charger).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            })
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('网络错误');
                    }
                });
            },



            // 进入选择组别
            ytEnterGroup: function() {
                this.c_yt_group_checkboxModel = this.yt_group_checkboxModel;
                this.yt_group_checkboxModel = [];
                this.getYtGroupData();
                this.yt_group_checkboxModel = this.c_yt_group_checkboxModel;
                $('.yt-list').hide();
                $('.yt-group').show();
            },
            // 获取组别列表
            getYtGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.ytShop).val(),
                            "key_word": 'personnel',
                            "group_name": _this.yt_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.yt_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupYtCheckedAll: function() {
                let _this = this;
                _this.yt_group_allcheck = _this.yt_c_group_allcheck;
                if(!_this.yt_group_allcheck) { // 实现全选
                    _this.yt_group_checkboxModel = [];
                    _this.yt_group_checkboxData.forEach(function(item) {
                        _this.yt_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.yt_group_checkboxModel = [];
                }
            },
            // 返回
            ytGroupBack: function() {
                $('.yt-group').hide();
                $('.yt-list').show();
                this.yt_group_checkboxModel = this.c_yt_group_checkboxModel;
            },
            ytGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.yt_group_checkboxData.forEach(function(item) {
                    _this.yt_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.yt_group_txt = arr.join(',');
                $('.yt-group').hide();
                $('.yt-list').show();
            },
            // 表格
            innitYtTable: function() {
                let _this = this;
                $(_this.$refs.ytList).bootstrapTable('destroy');
                $(_this.$refs.ytList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYtList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "group_name",
                        title: "组别",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "stage_name",
                        title: "艺人姓名",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "director_name",
                        title: "主管",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "room_name",
                        title: "上钟包厢",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "room_type_name",
                        title: "包厢类型",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "last_balance",
                        title: "上次余额",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "create_time",
                        title: "扣费时间",
                        width: "100",
                        valign: "middle"
                    }, {
                        field: "fee",
                        title: "扣费金额",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "refund_fee",
                        title: "账户<br />退回金额",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "current_balance",
                        title: "本次余额",
                        width: "8%",
                        valign: "middle"
                    }],
                });
            },
            // 数据
            getYtList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.ytShop).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ytStartTime,
                            "end_time": _this.ytEndTime,
                            "shop_id": shop_id,
                            "room_type": $.trim($(_this.$refs.ytBoxType).val()),
                            "room_id": $.trim($(_this.$refs.ytBox).val()),
                            "stage_name": _this.yt_user,
                            "group_id": _this.yt_group_checkboxModel,
                            "director_uid": $.trim($(_this.$refs.yt_charger).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getPersonnelChargeList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYtExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/personnelChargeExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ytExport_checkModel = data.response.result.export_fields;
                                _this.ytExport_type = data.response.result.export_type;
                            } else {
                                _this.ytExport_checkModel = _this.ytExport_checkData;
                                _this.ytExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ytExport_alert)
                }, function() {
                    _this.exportYtList();
                });
            },
            // 导出字段全选
            ytExportCheckedAll: function() {
                let _this = this;
                _this.ytExport_allcheck = _this.c_ytExport_allcheck;
                if(!_this.ytExport_allcheck) { // 实现全选
                    _this.ytExport_checkModel = [];
                    _this.ytExport_checkData.forEach(function(item) {
                        _this.ytExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ytExport_checkModel = [];
                }
            },
            // 导出
            exportYtList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.ytShop).val();
                let export_fields = JSON.stringify(_this.ytExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/personnelChargeExport?" +
                    "&start_time=" + _this.ytStartTime +
                    "&end_time=" + _this.ytEndTime +
                    "&shop_id=" + shop_id +
                    "&room_type=" + $.trim($(_this.$refs.ytBoxType).val()) +
                    "&room_id=" + $.trim($(_this.$refs.ytBox).val()) +
                    "&stage_name=" + _this.yt_user +
                    "&group_id=" + _this.yt_group_checkboxModel +
                    "&director_uid=" + $.trim($(_this.$refs.yt_charger).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ytExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .yt-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>